/**
 * Links into To decide (/work/actions). `?ask=<id>` opens that one ask —
 * scrolled to, highlighted, filters cleared; `?journey=<id>` lists one
 * journey's asks. Every link to an ask goes through these.
 */
export const askHref = (actionId: string) => `/work/actions?ask=${encodeURIComponent(actionId)}`;
export const journeyAsksHref = (orderId: string) => `/work/actions?journey=${encodeURIComponent(orderId)}`;
